import ServicesSection from "../../components/Home/ServicesSection";
import SuccessStories from "../../components/Stories/SuccessStories";
import HomeService from "../../components/Service/Home";
import Container from "../../components/ui/Container";
import { useAnimationControls } from "framer-motion";
import { useEffect } from "react";
import BlogsSection from "../../components/Blogs/BlogSection";
import SEO from "../../components/SEO";

const Home: React.FC = () => {
  const contentControls = useAnimationControls();


  useEffect(() => {
    contentControls.start({
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] },
    });
  }, []);

  return (
    <>

      <Container>
        <HomeService />
      </Container>

      <ServicesSection />
      <SuccessStories />
      <BlogsSection/>
    </>
  );
};

export default Home;
